module.exports = __webpack_public_path__ + "images/64da7134791cc64461974c898105d25f-tap_dial.png";